import { Tooltip as TooltipBase, type TooltipProps } from '@mui/material';

import { useFullScreen } from '../FullScreen';

export const Tooltip = (props: TooltipProps) => {
  const { ref } = useFullScreen();
  return <TooltipBase PopperProps={{ container: ref.current }} {...props} />;
};
